export default __webpack_public_path__ + "static/earth-plane-08d5e3bf8d314f49b365f21fb4705f29.svg";